<script lang="ts">
  import Form from "$components/form/Form/Form.svelte";
  import InputField from "$components/form/Fields/InputField.svelte";
  import ColorField from "$components/form/Fields/ColorField/ColorField.svelte";
  import { community } from "app/stores/community";
  import Button from "$components/+blocks/Button/Button.svelte";

  export let communityCreated: CallableFunction;

  const formId = "community-creation";

  let submitting = false;
  let color: string = "#6776FF";

  async function onSubmit(event: CustomEvent) {
    submitting = true;

    if (
      await community.create({
        ...event.detail,
        isPrivate: false,
        isKnowledgeBaseEnabled: true,
        isCommunityEnabled: false,
      })
    ) {
      communityCreated();
    }
  }
</script>

<Form
  id={formId}
  name={"onboarding-form"}
  class="flex flex-col p-8"
  on:submit={onSubmit}
  defaultValues={{
    name: "",
    primaryColor: color,
  }}
>
  <h3 class="mb-3 text-[13px] font-medium text-neutral-500 dark:text-neutral-300">
    Company name / accent color
  </h3>
  <div class="flex w-full items-start gap-3">
    <ColorField
      name="primaryColor"
      size="size-[42px]"
      bind:value={color}
      label="Accent color"
      labelHidden
    />
    <InputField
      name="name"
      wrapperClassname="w-full"
      validationRules={{ required: "This is required." }}
      label="Company name"
      labelHidden
    />
  </div>

  <div class="mt-6 w-full">
    <Button
      htmlButtonType="submit"
      variant="system"
      label={submitting ? "Creating workspace..." : "Next"}
      size="large"
      disabled={submitting}
      isFullWidth
    />
  </div>
</Form>
